import Vue from 'vue';
import VueRouter from 'vue-router';
import store from 'store';
Vue.use(VueRouter);
import {getSiteId, getUserMenu} from "../assets/js/api";
import {getToken} from "../utils/auth";

function load(path, type = 0) {
  const dir = type ? 'components' : 'views';
  return () => import(`@/${dir}/${path}.vue`);
}

const Router = new VueRouter({

  routes: [
    {
      path: '/',
      name: 'layout',
      component: load('layout'),
      redirect: 'index',
      children: [
        // {
        //   path: '/index',
        //   name: 'home',
        //   component: load('home'),
        // },
      ],
    },
    {
      path: '/',
      name: 'layout2',
      component: load('layout2'),
      children: [
        {
          path: '/index',
          name: 'home',
          component: load('home'),

        },
        {
          path: '/about',
          name: 'about',
          component: load('home/about'),
        },
        {
          path: '/live',
          name: 'live',
          component: load('live/live'),
        },
          {
              path: '/test',
              name: 'test',
              component: load('tiku/tiku'),
          },
          {
              path: '/result',
              name: 'result',
              component: load('study/result'),
          },
          {
              path: '/questionnaire',
              name: 'questionnaire',
              component: load('study/questionnaire'),
          },
          {
              path: '/paper',
              name: 'paper',
              component: load('study/paper'),
          },
          {
              path: '/scoreDetail',
              name: 'scoreDetail',
              component: load('study/scoreDetail'),
          },
        {
          path: '/study',
          name: 'study',
          component: load('study/study'),
        },
        {
          path: '/talk',
          name: 'talk',
          component: load('talk/talk'),
        },
        {
          path: '/serve',
          name: 'serve',
          component: load('serve/serve'),
        },
        {
          path: '/personal',
          name: 'personal',
          component: load('personal/personal'),
        },
        {
          path: '/msgDetail',
          name: 'msgDetail',
          component: load('personal/msgDetail'),
        },
      ],
    },
    // 非嵌套路由 必须以 / 开头
    {
      path: '/login',
      name: 'login',
      component: load('login/login'),
    },
    {
      path: '/video',
      name: 'video',
      component: load('study/video'),
    },
    {
      path: '/exam',
      name: 'exam',
      component: load('study/exam'),
    },
    {
      path: '/analysis',
      name: 'analysis',
      component: load('study/analysis'),
    },
    {
      path: '/report',
      name: 'report',
      component: load('study/report'),
    },
  ],
});

function except(modules, path) {
  let inPath = false;
  modules.map(n => {
    if (path.split('/')[1] == n) inPath = true;
  });
  return inPath;
}

Router.beforeEach((to, from, next) => {
  console.log("222222220000002")
  let user = localStorage.getItem("info")
  console.log(user)
    // getSiteId('humc.hnzkw.org.cn').then((res) => {
        getSiteId(document.domain).then((res) => {
    // getSiteId('smlv.yukao.com.cn').then((res) => {
    // getSiteId('sxbq.hnzkw.org.cn').then((res) => {
        console.log("站点信息")
        console.log(res);
        // if (res.code == 200) {
            console.log("siteId=  "+res.data.id)
            window.localStorage.setItem('siteId', res.data.id)
        window.localStorage.setItem('siteName', res.data.siteName)
        window.localStorage.setItem('setTime', res.data.setTime)
        window.localStorage.setItem('ecode', res.data.ecode)
        // }
    });

  if (to.path == "/login") {
    // next()
      next()
  } else {
    if (!user) {

      next('/login')
    } else {
      next()
    }

  }

});

export default Router;
